import React from "react";
import styled from "styled-components";
import { HeartFilled } from "@ant-design/icons";
const CoupleContainer = styled.div`
  background: #f2f2f2;
  /* position: relative; */
  /* top: -140px; */
  .intro {
    display: grid;
    justify-content: center;
    text-align: center;
  }
  .heart-divider {
    height: 100%;
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
  }
  .white-line {
    width: 30px;
    height: 8px;
    display: inline-block;
    border-top: solid 1px #fff;
  }
  .title {
    font-size: 40px;
    font-family: "Oswald", sans-serif;
    color: #333;
    padding: 20px 0;
    @media (max-width: 768px) {
      font-size: 170%;
    }
  }
  .text {
    /* font-family: "Arvo", serif;
    font-size: 16px; */
    line-height: 26px;
    margin-bottom: 25px;
    max-width: 945px;
    color: #6a6a6a;
  }
  .text {
    @media (max-width: 768px) {
      font-size: 120%;
      padding: 0 4%;
    }
  }
  .pink-dot {
    color: #f0394d;
  }
  #desc {
    font-family: muli;
    color: #123333;
    font-size: 16px;
  }
`;
export default function Couple() {
  return (
    <CoupleContainer>
      <div className="intro">
        <h3 className="title"> THE HAPPY COUPLE</h3>
        <p id="desc" className="text">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer
          ultrices malesuada ante quis
          <br /> pharetra. Nullam non bibendum dolor. Ut vel turpis accumsan,
          efficitur dolor fermentum, tincidunt metus.
        </p>
        <div className="heart-divider">
          <span className="white-line"></span>
          <HeartFilled className="pink-dot" style={{ fontSize: 18 }} />
          <HeartFilled
            style={{ fontSize: 18, marginLeft: -5, color: "white" }}
          />
          <span className="white-line"></span>
        </div>
      </div>
    </CoupleContainer>
  );
}
